import client from "../Client/HttpClient";
import { ISaberWeightsModel } from "@/interfaces/modules";

const ApiPath = "AcademicYearSaberWeights";

export default {
  GetAcademicYearSaberWeights: (): Promise<ISaberWeightsModel[]> => client.get(`${ApiPath}`),
  GetAcademicYearSaberWeightsById: (data: ISaberWeightsModel): Promise<ISaberWeightsModel> => client.get(`${ApiPath}/${data.Id}`),
  GetAcademicYearSaberWeightsByYearId: (data: ISaberWeightsModel): Promise<ISaberWeightsModel[]> => client.get(`${ApiPath}/byYear/${data.AcademicYearId}`),
  PostAcademicYearSaberWeights: (data: ISaberWeightsModel): Promise<ISaberWeightsModel> => client.post(`${ApiPath}`, data),
};
